__turbopack_context__.v({
  "avatar": "ActionPlanAssigneePickerCard-module__e95mfW__avatar",
  "card": "ActionPlanAssigneePickerCard-module__e95mfW__card",
  "done": "ActionPlanAssigneePickerCard-module__e95mfW__done",
  "empty": "ActionPlanAssigneePickerCard-module__e95mfW__empty",
  "head": "ActionPlanAssigneePickerCard-module__e95mfW__head",
  "headIcon": "ActionPlanAssigneePickerCard-module__e95mfW__headIcon",
  "headSub": "ActionPlanAssigneePickerCard-module__e95mfW__headSub",
  "headTitle": "ActionPlanAssigneePickerCard-module__e95mfW__headTitle",
  "item": "ActionPlanAssigneePickerCard-module__e95mfW__item",
  "itemMeta": "ActionPlanAssigneePickerCard-module__e95mfW__itemMeta",
  "itemName": "ActionPlanAssigneePickerCard-module__e95mfW__itemName",
  "itemPicked": "ActionPlanAssigneePickerCard-module__e95mfW__itemPicked",
  "itemText": "ActionPlanAssigneePickerCard-module__e95mfW__itemText",
  "list": "ActionPlanAssigneePickerCard-module__e95mfW__list",
  "tools": "ActionPlanAssigneePickerCard-module__e95mfW__tools",
});
